import axios from 'axios'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getHolidays(condition = {}) {
  let response = {}
  
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/HolidaySetting`)

  } catch (err) {
    console.error('iisi getHolidays: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response

}

export async function postHolidays(controlData = {}) {
  let response = {};
  if(Utils.isEmptyObject(controlData)) {

      console.error('iisi postHolidays: controlData is null')
      return null
  }

  try {
    response = await axios.post(`${config.eastCoastDataApi()}BaseData/HolidaySetting/uploadFile`, controlData)
  } catch (err) {
      console.error('iisi postHolidayFile: ', err)
      
  }

  Utils.setApiResponsSuccess(response)
  return response
}